import { EventEmitter } from 'events';

export class Realtime extends EventEmitter {
  private socket: WebSocket;
  constructor(channels: string[]) {
    super();
    this.socket = new WebSocket('wss://ws.lightstream.bitflyer.com/json-rpc');
    this.socket.onopen = () => {
      channels.forEach((channel) => this.subscribe(channel));
    };
    this.socket.onmessage = (message: MessageEvent) => {
      const res = JSON.parse(message.data);
      const data = res.params.message;
      switch (res.params.channel) {
        case 'lightning_board_snapshot_FX_BTC_JPY':
          this.emit('snapshot', data);
          break;
        case 'lightning_board_FX_BTC_JPY':
          this.emit('board', data);
          break;
        case 'lightning_executions_FX_BTC_JPY':
          this.emit('executions', data);
          break;
        case 'lightning_ticker_FX_BTC_JPY':
          this.emit('ticker', data);
          break;
        case 'lightning_ticker_BTC_JPY':
          this.emit('spot_ticker', data);
          break;
        default:
          break;
      }
    };
  }
  private subscribe(channel: string) {
    this.socket.send(
      JSON.stringify({
        method: 'subscribe',
        params: {
          channel,
        },
      }),
    );
  }
}
